module.exports = __webpack_public_path__ + "static/Impact_3_Up-6002b71d43f189a2b4f5b847e267c866.svg";